import { IconType } from "react-icons";
import {
    TbAlertCircle,
    TbAward,
    TbBadge,
    TbBell,
    TbBookmark,
    TbBriefcase,
    TbBuilding,
    TbCalendar,
    TbChartBar,
    TbChartLine,
    TbChartPie,
    TbCheck,
    TbClock,
    TbCloud,
    TbCrown,
    TbDatabase,
    TbDiamond,
    TbEye,
    TbEyeOff,
    TbFileText,
    TbFilter,
    TbFlag,
    TbFlame,
    TbFolder,
    TbHeart,
    TbHome,
    TbInfoCircle,
    TbKey,
    TbLabel,
    TbLock,
    TbMail,
    TbMap,
    TbMedal,
    TbMessage,
    TbPhone,
    TbQuestionMark,
    TbRocket,
    TbSearch,
    TbServer,
    TbSettings,
    TbShield,
    TbStar,
    TbTag,
    TbTarget,
    TbThumbDown,
    TbThumbUp,
    TbTrendingDown,
    TbTrendingUp,
    TbTrophy,
    TbUser,
    TbUsers,
    TbX,
} from "react-icons/tb";

export const PRESET_ICONS: Array<{ name: string; component: IconType }> = [
    { name: "TbBookmark", component: TbBookmark },
    { name: "TbChartBar", component: TbChartBar },
    { name: "TbChartLine", component: TbChartLine },
    { name: "TbChartPie", component: TbChartPie },
    { name: "TbUsers", component: TbUsers },
    { name: "TbUser", component: TbUser },
    { name: "TbStar", component: TbStar },
    { name: "TbTarget", component: TbTarget },
    { name: "TbTrophy", component: TbTrophy },
    { name: "TbTrendingUp", component: TbTrendingUp },
    { name: "TbTrendingDown", component: TbTrendingDown },
    { name: "TbFlag", component: TbFlag },
    { name: "TbBell", component: TbBell },
    { name: "TbCalendar", component: TbCalendar },
    { name: "TbClock", component: TbClock },
    { name: "TbCheck", component: TbCheck },
    { name: "TbX", component: TbX },
    { name: "TbAlertCircle", component: TbAlertCircle },
    { name: "TbInfoCircle", component: TbInfoCircle },
    { name: "TbQuestionMark", component: TbQuestionMark },
    { name: "TbHeart", component: TbHeart },
    { name: "TbThumbUp", component: TbThumbUp },
    { name: "TbThumbDown", component: TbThumbDown },
    { name: "TbEye", component: TbEye },
    { name: "TbEyeOff", component: TbEyeOff },
    { name: "TbSearch", component: TbSearch },
    { name: "TbFilter", component: TbFilter },
    { name: "TbSettings", component: TbSettings },
    { name: "TbHome", component: TbHome },
    { name: "TbBuilding", component: TbBuilding },
    { name: "TbBriefcase", component: TbBriefcase },
    { name: "TbPhone", component: TbPhone },
    { name: "TbMail", component: TbMail },
    { name: "TbMessage", component: TbMessage },
    { name: "TbFileText", component: TbFileText },
    { name: "TbFolder", component: TbFolder },
    { name: "TbDatabase", component: TbDatabase },
    { name: "TbServer", component: TbServer },
    { name: "TbCloud", component: TbCloud },
    { name: "TbLock", component: TbLock },
    { name: "TbKey", component: TbKey },
    { name: "TbShield", component: TbShield },
    { name: "TbRocket", component: TbRocket },
    { name: "TbMap", component: TbMap },
    { name: "TbFlame", component: TbFlame },
    { name: "TbDiamond", component: TbDiamond },
    { name: "TbCrown", component: TbCrown },
    { name: "TbAward", component: TbAward },
    { name: "TbMedal", component: TbMedal },
    { name: "TbBadge", component: TbBadge },
    { name: "TbTag", component: TbTag },
    { name: "TbLabel", component: TbLabel },
] as const;

export type PresetIconName = (typeof PRESET_ICONS)[number]["name"];

export function getIconByName(name: PresetIconName): IconType | undefined {
    return PRESET_ICONS.find((icon) => icon.name === name)?.component;
}
